import styled from 'styled-components';

export const PdfErrorContainer = styled.div`
  text-align: center;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 24px;
`;

export const Th = styled.th`
  background-color: ${({ theme }) => theme.colors.yellow.primary};
  padding: 8px 4px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.navy};
  text-align: left;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 24px 16px;
  }
`;

export const Td = styled.td`
  padding: 8px 4px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.navy};
  vertical-align: top;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 24px 16px;
  }
`;

export const TableRow = styled.tr`
  &:hover {
    background: ${({ theme }) => theme.colors.neutral.lavenderLight};
  }
`;
